<template>
  <div class="home">
    <v-layout row>
      <v-flex xs12>
        <!--<v-card>
      <p class="red">Sorry, the page you're looking for doesn't exist.</p>
      </v-card>-->
      <v-jumbotron>
         <p class="display-4 text-xs-center font-weight-medium pt-5">404</p>
            <div class="display-1  text-xs-center">{{msg}}</div>
      </v-jumbotron>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data () {
    return {
      msg: 'Sorry, the page you\'re looking for doesn\'t exist.'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/error/404.vue